// import {
//   Alert,
//   Snackbar,
//   useTheme,
//   Paper,
//   Typography,
//   Box,
//   IconButton,
//   Tooltip,
//   Divider,
//   Chip,
// } from '@mui/material';
// import React, { useState } from 'react';
// import { Table } from 'react-bootstrap';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

// export const LeedintegrationKeys = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   // State for individual copy feedback
//   const [copiedKey, setCopiedKey] = useState(null);

//   const handleCopy = (key) => {
//     setCopiedKey(key);
//     setTimeout(() => setCopiedKey(null), 2000);
//   };

//   // Data for keys
//   const keysData = [
//     { key: 'name', example: 'Johan Dee', description: 'Lead full name' },
//     { key: 'email', example: 'Johan_Dee@gmail.com', description: 'Lead email address' },
//     { key: 'phone', example: '503499171', description: 'Primary phone number' },
//     { key: 'whatsappnumber', example: '503499171', description: 'WhatsApp number' },
//     { key: 'phonenumber2', example: '503499171', description: 'Secondary phone number' },
//     { key: 'jobdescription', example: 'Director', description: 'Job title/description' },
//     // ✅ New Question Keys
//     { key: 'question1_text', example: 'What is your budget?', description: 'Question #1 text' },
//     { key: 'question1_answer', example: '1.5M - 2M AED', description: 'Answer for question #1' },
//     { key: 'question2_text', example: 'Preferred payment plan?', description: 'Question #2 text' },
//     {
//       key: 'question2_answer',
//       example: '5 years installment',
//       description: 'Answer for question #2',
//     },
//     {
//       key: 'question3_text',
//       example: 'Any specific requirements?',
//       description: 'Question #3 text',
//     },
//     {
//       key: 'question3_answer',
//       example: 'Sea view preferred',
//       description: 'Answer for question #3',
//     },
//     {
//       key: 'question4_text',
//       example: 'Handover date preference?',
//       description: 'Question #4 text',
//     },
//     { key: 'question4_answer', example: 'Q4 2025', description: 'Answer for question #4' },
//     { key: 'question5_text', example: 'Previous experience?', description: 'Question #5 text' },
//     { key: 'question5_answer', example: 'First time buyer', description: 'Answer for question #5' },
//           { key: 'campaignRedirectLink', example: 'https://www.google.ae/index.html?zx=1772797161955&no_sw_cr=1', description: 'Go To Campain Link' },

//   ];

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         mt: 4,
//         p: 3,
//         borderRadius: 3,
//         backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//         border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <QuestionAnswerIcon sx={{ color: '#102dff', fontSize: 28 }} />
//           <Typography
//             variant="h5"
//             sx={{
//               fontWeight: '600',
//               color: mode === 'dark' ? '#fff' : '#102dff',
//             }}
//           >
//             Integration Keys Reference
//           </Typography>
//         </Box>
//         <Chip
//           label={`${keysData.length} Keys Available`}
//           size="small"
//           sx={{
//             backgroundColor: '#102dff',
//             color: 'white',
//             fontWeight: '500',
//           }}
//         />
//       </Box>

//       <Typography
//         variant="body2"
//         sx={{
//           mb: 3,
//           color: mode === 'dark' ? '#aaa' : '#666',
//           fontStyle: 'italic',
//         }}
//       >
//         Use these keys in your integration to map the lead fields correctly. Click the copy icon to
//         copy the key.
//       </Typography>

//       <Divider sx={{ mb: 3, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />

//       {/* Table */}
//       <Table
//         responsive
//         hover
//         style={{
//           backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//           borderRadius: '12px',
//           overflow: 'hidden',
//         }}
//       >
//         <thead>
//           <tr
//             style={{
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
//               borderBottom: `2px solid ${mode === 'dark' ? '#444' : '#102dff'}`,
//             }}
//           >
//             <th
//               style={{
//                 textAlign: 'center',
//                 padding: '16px',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 fontWeight: '600',
//                 fontSize: '14px',
//               }}
//             >
//               Key
//             </th>
//             <th
//               style={{
//                 textAlign: 'center',
//                 padding: '16px',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 fontWeight: '600',
//                 fontSize: '14px',
//               }}
//             >
//               Description
//             </th>
//             <th
//               style={{
//                 textAlign: 'center',
//                 padding: '16px',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 fontWeight: '600',
//                 fontSize: '14px',
//               }}
//             >
//               Example Value
//             </th>
//             <th
//               style={{
//                 textAlign: 'center',
//                 padding: '16px',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 fontWeight: '600',
//                 fontSize: '14px',
//               }}
//             >
//               Copy Key
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {keysData.map((item, index) => (
//             <tr
//               key={item.key}
//               style={{
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//                 borderBottom: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//                 transition: 'background-color 0.2s',
//                 cursor: 'pointer',
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = mode === 'dark' ? '#2d2d2d' : '#f8f9fa';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = mode === 'dark' ? '#1e1e1e' : '#fff';
//               }}
//             >
//               <td
//                 style={{
//                   textAlign: 'center',
//                   padding: '14px',
//                   color: mode === 'dark' ? '#90caf9' : '#102dff',
//                   fontWeight: '500',
//                   fontFamily: 'monospace',
//                   fontSize: '13px',
//                 }}
//               >
//                 {item.key}
//               </td>
//               <td
//                 style={{
//                   textAlign: 'center',
//                   padding: '14px',
//                   color: mode === 'dark' ? '#ddd' : '#555',
//                   fontSize: '13px',
//                 }}
//               >
//                 {item.description}
//               </td>
//               <td
//                 style={{
//                   textAlign: 'center',
//                   padding: '14px',
//                   color: mode === 'dark' ? '#fff' : '#333',
//                   fontSize: '13px',
//                   fontWeight: '500',
//                 }}
//               >
//                 "{item.example}"
//               </td>
//               <td
//                 style={{
//                   textAlign: 'center',
//                   padding: '14px',
//                 }}
//               >
//                 <CopyToClipboard text={item.key} onCopy={() => handleCopy(item.key)}>
//                   <Tooltip
//                     title={copiedKey === item.key ? 'Copied!' : 'Copy key'}
//                     arrow
//                     placement="top"
//                   >
//                     <IconButton
//                       size="small"
//                       sx={{
//                         backgroundColor: copiedKey === item.key ? '#4caf50' : '#102dff',
//                         color: 'white',
//                         width: 32,
//                         height: 32,
//                         '&:hover': {
//                           backgroundColor: copiedKey === item.key ? '#45a049' : '#0a25d9',
//                         },
//                         transition: 'all 0.2s',
//                       }}
//                     >
//                       {copiedKey === item.key ? (
//                         <CheckCircleIcon sx={{ fontSize: 18 }} />
//                       ) : (
//                         <ContentCopyIcon sx={{ fontSize: 18 }} />
//                       )}
//                     </IconButton>
//                   </Tooltip>
//                 </CopyToClipboard>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       {/* Notes Section */}
//       <Box
//         sx={{
//           mt: 3,
//           p: 2,
//           backgroundColor: mode === 'dark' ? 'rgba(16,45,255,0.1)' : 'rgba(16,45,255,0.05)',
//           borderRadius: 2,
//           border: `1px solid ${mode === 'dark' ? 'rgba(16,45,255,0.3)' : 'rgba(16,45,255,0.2)'}`,
//         }}
//       >
//         <Typography
//           variant="subtitle2"
//           sx={{
//             color: mode === 'dark' ? '#90caf9' : '#102dff',
//             fontWeight: '600',
//             mb: 1,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           📝 Important Notes:
//         </Typography>
//         <ul
//           style={{
//             margin: 0,
//             paddingLeft: '20px',
//             color: mode === 'dark' ? '#ddd' : '#555',
//             fontSize: '13px',
//           }}
//         >
//           <li>All keys are case-sensitive - use exactly as shown</li>
//           <li>
//             Questions are optional - only include if you want to capture additional information
//           </li>
//           <li>
//             For each question, you need both the text and answer keys (e.g., question1_text and
//             question1_answer)
//           </li>
//           <li>You can include up to 5 questions in your integration</li>
//           <li>Empty questions will be ignored automatically</li>
//         </ul>
//       </Box>

//       {/* Global Snackbar for backward compatibility */}
//       <Snackbar
//         open={copiedKey !== null}
//         autoHideDuration={2000}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           severity="success"
//           sx={{
//             width: '100%',
//             backgroundColor: mode === 'dark' ? '#2e7d32' : '#4caf50',
//             color: 'white',
//             '& .MuiAlert-icon': {
//               color: 'white',
//             },
//           }}
//         >
//           Key "{copiedKey}" copied to clipboard!
//         </Alert>
//       </Snackbar>
//     </Paper>
//   );
// };
































// 20-5-2026
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from '@mui/material/styles';
import { Snackbar, Alert } from '@mui/material';
import CopyToClipboard from 'react-copy-to-clipboard';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconCopy  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconCheck = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconKeys  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IconClose = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

/* ─── Data ───────────────────────────────────────────────────────────────── */
const keysData = [
  { key: 'name',               example: 'Johan Dee',              description: 'Lead full name',           group: 'basic'    },
  { key: 'email',              example: 'Johan_Dee@gmail.com',    description: 'Lead email address',        group: 'basic'    },
  { key: 'phone',              example: '503499171',              description: 'Primary phone number',      group: 'basic'    },
  { key: 'whatsappnumber',     example: '503499171',              description: 'WhatsApp number',           group: 'basic'    },
  { key: 'phonenumber2',       example: '503499171',              description: 'Secondary phone number',    group: 'basic'    },
  { key: 'jobdescription',     example: 'Director',               description: 'Job title / description',  group: 'basic'    },
  { key: 'campaignRedirectLink', example: 'https://example.com', description: 'Campaign redirect link',    group: 'basic'    },
  { key: 'question1_text',     example: 'What is your budget?',   description: 'Question #1 text',         group: 'question' },
  { key: 'question1_answer',   example: '1.5M - 2M AED',         description: 'Answer for question #1',   group: 'question' },
  { key: 'question2_text',     example: 'Preferred payment plan?',description: 'Question #2 text',         group: 'question' },
  { key: 'question2_answer',   example: '5 years installment',    description: 'Answer for question #2',   group: 'question' },
  { key: 'question3_text',     example: 'Any specific requirements?', description: 'Question #3 text',    group: 'question' },
  { key: 'question3_answer',   example: 'Sea view preferred',     description: 'Answer for question #3',   group: 'question' },
  { key: 'question4_text',     example: 'Handover date preference?', description: 'Question #4 text',     group: 'question' },
  { key: 'question4_answer',   example: 'Q4 2025',                description: 'Answer for question #4',  group: 'question' },
  { key: 'question5_text',     example: 'Previous experience?',   description: 'Question #5 text',        group: 'question' },
  { key: 'question5_answer',   example: 'First time buyer',       description: 'Answer for question #5',  group: 'question' },
];

const basicKeys    = keysData.filter(k => k.group === 'basic');
const questionKeys = keysData.filter(k => k.group === 'question');

/* ─── KeyRow ─────────────────────────────────────────────────────────────── */
const KeyRow = ({ item, isDark, copiedKey, onCopy }) => {
  const isCopied = copiedKey === item.key;
  return (
    <tr
      onMouseEnter={e => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.03)' : 'rgba(37,99,235,0.03)'; }}
      onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
      style={{ transition: 'background 0.15s' }}
    >
      <td style={{ padding: '11px 14px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}`, whiteSpace: 'nowrap' }}>
        <code style={{ padding: '3px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 700, backgroundColor: isDark ? 'rgba(99,102,241,0.12)' : 'rgba(99,102,241,0.08)', color: isDark ? '#a5b4fc' : '#4f46e5', border: `1px solid ${isDark ? 'rgba(99,102,241,0.2)' : 'rgba(99,102,241,0.15)'}`, fontFamily: 'monospace' }}>
          {item.key}
        </code>
      </td>
      <td style={{ padding: '11px 14px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}`, fontSize: '12px', color: isDark ? '#9ca3af' : '#64748b' }}>
        {item.description}
      </td>
      <td style={{ padding: '11px 14px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}`, fontSize: '12px' }}>
        <span style={{ padding: '2px 7px', borderRadius: '6px', backgroundColor: isDark ? 'rgba(74,222,128,0.08)' : 'rgba(22,163,74,0.06)', color: isDark ? '#4ade80' : '#16a34a', border: `1px solid ${isDark ? 'rgba(74,222,128,0.15)' : 'rgba(22,163,74,0.12)'}`, fontSize: '11px', fontFamily: 'monospace' }}>
          "{item.example}"
        </span>
      </td>
      <td style={{ padding: '11px 14px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#f0f0f0'}`, textAlign: 'center' }}>
        <CopyToClipboard text={item.key} onCopy={() => onCopy(item.key)}>
          <button
            title={isCopied ? 'Copied!' : 'Copy key'}
            style={{ width: 30, height: 30, borderRadius: '7px', border: 'none', cursor: 'pointer', background: isCopied ? (isDark ? 'rgba(74,222,128,0.15)' : 'rgba(22,163,74,0.1)') : 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', color: isCopied ? (isDark ? '#4ade80' : '#16a34a') : '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', boxShadow: isCopied ? 'none' : '0 2px 8px rgba(29,78,216,0.3)' }}
          >
            {isCopied ? <IconCheck /> : <IconCopy />}
          </button>
        </CopyToClipboard>
      </td>
    </tr>
  );
};

/* ─── KeySection ─────────────────────────────────────────────────────────── */
const KeySection = ({ title, subtitle, keys, isDark, copiedKey, onCopy, accentColor }) => (
  <div style={{ backgroundColor: isDark ? '#1a1d2e' : '#fff', borderRadius: '12px', border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0', overflow: 'hidden', marginBottom: '16px' }}>
    <div style={{ padding: '14px 18px', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.01)' }}>
      <div>
        <p style={{ margin: 0, fontSize: '10px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8' }}>{subtitle}</p>
        <p style={{ margin: '1px 0 0', fontSize: '14px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e' }}>{title}</p>
      </div>
      <span style={{ padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, backgroundColor: `${accentColor}18`, color: accentColor, border: `1px solid ${accentColor}30` }}>
        {keys.length} keys
      </span>
    </div>
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'DM Sans',sans-serif" }}>
        <thead>
          <tr style={{ backgroundColor: isDark ? '#151827' : '#f8fafc' }}>
            {['KEY', 'DESCRIPTION', 'EXAMPLE VALUE', 'COPY'].map(h => (
              <th key={h} style={{ padding: '10px 14px', fontSize: '10px', fontWeight: 700, letterSpacing: '0.06em', color: isDark ? '#6b7280' : '#94a3b8', textAlign: h === 'COPY' ? 'center' : 'left', borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, whiteSpace: 'nowrap' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {keys.map(item => <KeyRow key={item.key} item={item} isDark={isDark} copiedKey={copiedKey} onCopy={onCopy} />)}
        </tbody>
      </table>
    </div>
  </div>
);

/* ─── CSS (injected once) ────────────────────────────────────────────────── */
const CSS = `
  @keyframes lik-fade  { from{opacity:0} to{opacity:1} }
  @keyframes lik-slide { from{opacity:0;transform:translateY(18px) scale(0.97)} to{opacity:1;transform:none} }
`;
let cssInjected = false;
const injectCSS = () => { if (!cssInjected) { cssInjected=true; const el=document.createElement('style'); el.innerHTML=CSS; document.head.appendChild(el); } };

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const LeedintegrationKeys = () => {
  injectCSS();

  const theme  = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const [open,      setOpen]      = useState(false);
  const [copiedKey, setCopiedKey] = useState(null);

  const handleCopy = (key) => {
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 2000);
  };

  return (
    <>
      {/* ── Trigger Button ── */}
      <button
        onClick={() => setOpen(true)}
        style={{
          width: '100%', padding: '13px 16px', borderRadius: '10px',
          border: `1.5px solid ${open ? '#1d4ed8' : (isDark ? '#2d3248' : '#e2e8f0')}`,
          backgroundColor: 'transparent',
          color: isDark ? '#9ca3af' : '#64748b',
          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          fontFamily: "'DM Sans',sans-serif", fontSize: '13px', fontWeight: 600,
          transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = '#1d4ed8'; e.currentTarget.style.color = isDark ? '#93c5fd' : '#1d4ed8'; e.currentTarget.style.backgroundColor = isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.04)'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; e.currentTarget.style.backgroundColor = 'transparent'; }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <IconKeys /> Integration Keys Reference
        </span>
        <span style={{ fontSize: '12px', opacity: 0.6 }}>{keysData.length} keys →</span>
      </button>

      {/* ── Dialog via Portal ── */}
      {open && createPortal(
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', animation: 'lik-fade 0.18s ease both' }}
          onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
        >
          <div style={{
            width: '100%', maxWidth: '780px', maxHeight: '88vh', margin: '0 16px',
            borderRadius: '20px', overflow: 'hidden', display: 'flex', flexDirection: 'column',
            background: isDark ? 'linear-gradient(135deg,#1a1f2e,#141829)' : '#fff',
            boxShadow: '0 40px 80px rgba(0,0,0,0.4)',
            animation: 'lik-slide 0.24s cubic-bezier(0.34,1.2,0.64,1) both',
          }}>

            {/* Dialog header */}
            <div style={{ background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: 38, height: 38, borderRadius: '10px', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                  <IconKeys />
                </div>
                <div>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#fff' }}>Integration Keys Reference</p>
                  <p style={{ margin: '2px 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.65)' }}>Use these keys to map lead fields correctly — {keysData.length} keys available</p>
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                style={{ width: 34, height: 34, borderRadius: '9px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.15)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0, transition: 'all 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.25)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
              >
                <IconClose />
              </button>
            </div>

            {/* Dialog body */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>

              {/* Basic Fields */}
              <KeySection title="Basic Lead Fields" subtitle="Core Fields" keys={basicKeys} isDark={isDark} copiedKey={copiedKey} onCopy={handleCopy} accentColor="#1d4ed8" />

              {/* Question Fields */}
              <KeySection title="Question & Answer Fields" subtitle="Optional Fields" keys={questionKeys} isDark={isDark} copiedKey={copiedKey} onCopy={handleCopy} accentColor="#7c3aed" />

              {/* Notes */}
              <div style={{ padding: '16px 18px', borderRadius: '12px', backgroundColor: isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.04)', border: `1px solid ${isDark ? 'rgba(37,99,235,0.2)' : 'rgba(37,99,235,0.12)'}` }}>
                <p style={{ margin: '0 0 8px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: isDark ? '#93c5fd' : '#1d4ed8' }}>📝 Important Notes</p>
                <ul style={{ margin: 0, paddingLeft: '16px', fontSize: '12px', color: isDark ? '#9ca3af' : '#64748b', lineHeight: 1.9 }}>
                  <li>All keys are <strong style={{ color: isDark ? '#e5e7eb' : '#374151' }}>case-sensitive</strong> — use exactly as shown</li>
                  <li>Questions are optional — only include if you want to capture additional information</li>
                  <li>For each question, include both the <code style={{ padding: '1px 5px', borderRadius: 4, backgroundColor: isDark ? 'rgba(99,102,241,0.15)' : 'rgba(99,102,241,0.08)', color: isDark ? '#a5b4fc' : '#4f46e5', fontSize: '11px' }}>_text</code> and <code style={{ padding: '1px 5px', borderRadius: 4, backgroundColor: isDark ? 'rgba(99,102,241,0.15)' : 'rgba(99,102,241,0.08)', color: isDark ? '#a5b4fc' : '#4f46e5', fontSize: '11px' }}>_answer</code> keys</li>
                  <li>You can include up to <strong style={{ color: isDark ? '#e5e7eb' : '#374151' }}>5 questions</strong> in your integration</li>
                  <li>Empty questions will be ignored automatically</li>
                </ul>
              </div>
            </div>

            {/* Dialog footer */}
            <div style={{ padding: '14px 24px', borderTop: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`, flexShrink: 0 }}>
              <button
                onClick={() => setOpen(false)}
                style={{ width: '100%', padding: '11px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)', color: '#fff', fontFamily: "'DM Sans',sans-serif", fontSize: '13px', fontWeight: 700, cursor: 'pointer', letterSpacing: '0.06em' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Snackbar */}
      <Snackbar open={copiedKey !== null} autoHideDuration={2000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="success" sx={{ width: '100%' }}>
          Key <strong>"{copiedKey}"</strong> copied!
        </Alert>
      </Snackbar>
    </>
  );
};